// extracted by mini-css-extract-plugin
export default {"videoSplit":"videoSplit__X1mow","xt150":"xt150__KCvHQ","xt60":"xt60__eRdgl","faq":"faq__-Xver","floatLeft":"floatLeft__STEd4"};